import { dateFormatter, opcoConverter } from '../../helpers/utilities';
import EditButton from '../../components/Grid/EditButton';
import ViewButton from '../../components/Grid/ViewButton';
import DeleteBtn from '../../components/Grid/DeleteButton';
export const gridResponse = {
  field: [
    {
      field: 'appNb',
    },
    {
      field: 'cprProjectNb',
    },
    {
      field: 'appType',
    },
   
    {
      field: 'premiseNb',
    },
    {
      field: 'opcoName',
    },
    {
      field: 'appStatusGroup',
    },
    {
      field: 'appStatus',
    },
    {
      field: 'statusTime',
    },
    {
      field: 'creationTs',
    },
    {
      field: 'verifyTs',
    },   
    {
      field: 'view',
    },
    {
      field: 'edit',
    },

    {
      field: 'delete',
    },
  ],
};

export const projectsGridConfig = {
  pageSize: 30,
  gridName: 'projects',
  projectGridHeader: [
    {
      headerName: 'Application No',
      field: 'appNb',
      pinned: 'left',
      minWidth: 150
    },
    { headerName: 'Project No', field: 'cprProjectNb',minWidth: 150},
    { headerName: 'Type', field: 'appType',minWidth: 150},
    { headerName: 'Premise No.', field: 'premiseNb',minWidth: 150},
    { headerName: 'Status Group', field: 'appStatusGroup' ,minWidth: 150},
    { headerName: 'Operating Co.', field: 'opcoName',minWidth: 150, valueFormatter:opcoConverter},
    { headerName: 'Status', field: 'appStatus',minWidth: 150 },
    {
      headerName: 'Status Date',
      field: 'statusTime',
      valueFormatter: dateFormatter,
      minWidth: 150
    },
    {
      headerName: 'Creation Date',
      field: 'creationTs',
      valueFormatter: dateFormatter,
      minWidth: 150
    },
    {
      headerName: 'Verified Date',
      field: 'verifyTs',
      valueFormatter: dateFormatter,
      minWidth: 150
    },
    {
      headerName: '',
      field: 'view',
      pinned: 'right',
      maxWidth: 45,
      cellRenderer: ViewButton,
    },
    {
      headerName: '',
      field: 'edit',
      pinned: 'right',
      maxWidth: 45,
      cellRenderer: EditButton,
    },
    {
      headerName: '',
      field: 'delete',
      pinned: 'right',
      maxWidth: 45,
      cellRenderer: DeleteBtn,
    },
  ],
  schema: {
    appNb: 'string',
    cprProjectNb:'string',
    appType: 'string',
    premiseNb: 'string',
    appStatusGroup: 'string',
    opcoName: 'string',
    appStatus: 'string',
    statusTime: 'date',
    creationTs: 'date',
    verifyTs: 'date',
  },
};
